// RiskaiA Sales Control Center — sub-application mounted at /sales/* by the
// operations frontend (see ../App.js). Ported from the Deal-Funnel dump.
//
// It runs inside the operations BrowserRouter, so it does NOT create its own
// router: the routes below are RELATIVE to the /sales mount, while every
// navigation target (NavLink/Navigate/navigate) uses an ABSOLUTE /sales/... URL.
// The dark theme + custom classes are scoped under `.sales-theme` so they do not
// leak into the marketing site (see sales.css).
import "./sales.css";
import { Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "@/sales/pages/Dashboard";
import GoldenStandard from "@/sales/pages/GoldenStandard";
import ContactMoments from "@/sales/pages/ContactMoments";
import Users from "@/sales/pages/Users";
import Login from "@/sales/pages/Login";
import Header from "@/sales/components/Header";
import { AuthProvider, useAuth } from "@/sales/auth/AuthContext";
import ProtectedRoute from "@/sales/auth/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

function AuthenticatedShell({ children }) {
  return (
    <>
      <Header />
      {children}
    </>
  );
}

function SalesRoutes() {
  const { ready } = useAuth();
  if (!ready) {
    return (
      <div
        data-testid="app-boot"
        className="min-h-screen w-full grid place-items-center bg-[#0B1521] text-[#94A3B8] text-xs uppercase tracking-[0.22em]"
      >
        Laden…
      </div>
    );
  }
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route
        path=""
        element={
          <ProtectedRoute>
            <AuthenticatedShell>
              <Dashboard />
            </AuthenticatedShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="gouden-standaard"
        element={
          <ProtectedRoute>
            <AuthenticatedShell>
              <GoldenStandard />
            </AuthenticatedShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="traject/:dealId/voortgang"
        element={
          <ProtectedRoute>
            <AuthenticatedShell>
              <ContactMoments />
            </AuthenticatedShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="gebruikers"
        element={
          <ProtectedRoute requireBestuurslid>
            <AuthenticatedShell>
              <Users />
            </AuthenticatedShell>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/sales" replace />} />
    </Routes>
  );
}

export default function SalesApp() {
  return (
    <div className="sales-theme App min-h-screen bg-[#0B1521] text-[#F8FAFC] noise-overlay">
      <AuthProvider>
        <SalesRoutes />
      </AuthProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#142539",
            border: "1px solid rgba(192, 192, 192, 0.2)",
            color: "#F8FAFC",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}
